<template>
	<div class="l-edit-dialog-box" style="max-height: 75vh; height: 75vh" v-loading="loading">
		<el-form :model="form_data" label-width="110px" ref="form" :rules="rules" label-position="left">
			<el-row :gutter="30">
				<el-col :span="12">
					<el-form-item label="处置类型" prop="type">
						<el-select v-model="form_data.type" filterable placeholder="请选择处置类型" clearable>
							<el-option v-for="item in types" :key="item.value" :label="item.name" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="处置日期" prop="dispose_date">
						<el-date-picker v-model="form_data.dispose_date" type="date" style="width: 100%" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="处置金额(元)" prop="money">
						<el-input type="number" placeholder="请输入处置金额" v-model="form_data.money"> </el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<el-form-item label="备注" prop="remark">
				<el-input type="textarea" autosize placeholder="请输入备注" v-model="form_data.remark"> </el-input>
			</el-form-item>
			<el-form-item label="附件" prop="files">
				<el-upload class="upload-demo" name="file" drag :action="upload_action" :file-list="file_list" :on-success="handleImgUploadSuccess" :on-remove="handleRemove">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-form-item>
		</el-form>

		<!--已选的资产-->
		<l-divider></l-divider>
		<div>
			<div style="margin-bottom: 10px" v-show="type == 1">
				<div class="l-text-btn" @click="selecAssets">选择资产</div>
				<l-text-button type="danger" :disabled="del_selected_ids.length == 0" style="margin-left: 10px" @click="multiDel">批量移除</l-text-button>
				<span style="float: right">已选 {{ form_data.assets_ids.length }} 个</span>
			</div>
			<l-assets-common-table ref="assets_table" :data="selected_assets" @selection-change="handleSelectionChange" @del="del" row-key="id" :readonly="type != 1"></l-assets-common-table>
		</div>

		<!--打开选择资产界面-->
		<l-dialog :visible.sync="show_select_assets" title="选择处置资产" width="1000px">
			<l-assets-common-select @on-select="onSelectSuccess" :type="5" :select-ids="form_data.assets_ids" :visible.sync="show_select_assets" />
		</l-dialog>

		<div class="l-dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
		</div>
	</div>
</template>

<script>
import { dateToStr } from "@/utils/Fuc";
import { types } from "./types";
import AssetsTable from "../assets/CommonTable";
import CommonSelect from "../assets/CommonSelect";
import Vue from "vue";
export default {
	name: "l-assets-dispose-edit",
	components: {
		[AssetsTable.name]: AssetsTable,
		[CommonSelect.name]: CommonSelect,
	},
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
		visible: {
			type: Boolean,
		},
		type: {
			type: [Number, String],
			default: 1, //普通的处置  2盘点处置（带设备ID）
		},
		//盘点处置传入的ID
		assetsIds: {
			type: Array,
		},
		//处置来源  1普通  2盘点时进行盘亏处理
		disposeSource: {
			type: [Number, String],
			default: 1,
		},

		//处置来源ID
		sourceId: {
			type: [Number, String],
			default: 0,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== null;
		},
	},
	data() {
		return {
			loading: false,

			show_select_assets: false,

			is_first: true,

			//表单数据
			submitting: false,

			org_tree: [],
			curr_use_org_name: "",
			defaultProps: {
				children: "children",
				label: "name",
			},

			del_selected_ids: [],

			selected_assets: [],
			types: types,
			upload_action: Vue.$_config.api.domain + "/v1/upload/dispose_file", //照片上传地址
			file_list: [],
			form_data: {
				assets_ids: [],
				dispose_date: dateToStr(new Date(), "date"),
				type: "",
				money: "",
				source_id: 0,
				dispose_source: 1,
				files: [],
				remark: "",
			},

			rules: {
				type: [{ required: true, message: "请选择处置类型", trigger: "change" }],
				dispose_date: [{ required: true, message: "请选择处置日期", trigger: "change" }],
			},
		};
	},

	watch: {
		visible: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getData();
				}
			},
		},
	},

	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},
		//获取添加数据
		getData() {
			if (this.hasId) {
				//获取重新申请信息
				this.loading = true;
				this.$_invoke("assetsDispose_getReapplyData", { id: this.$props.id })
					.then((ret) => {
						this.form_data = ret.form_data;
						this.selected_assets = ret.selected_assets;
						this.file_list = ret.file_list;
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.is_first = false;
				if (this.$props.type != 1) {
					this.$_invoke("assetsDispose_getAddData", { type: this.$props.type, assets_ids: this.$props.assetsIds }).then((ret) => {
						this.selected_assets = ret.selected_assets;
						this.form_data.assets_ids = ret.assets_ids;
					});
				}

				// //添加获取数据
				// this.loading = true;
				// this.$_invoke("assetsBorrow_getAddData")
				// 	.then((ret) => {
				// 		this.org_tree = ret.org_tree;
				// 	})
				// 	.finally(() => {
				// 		this.loading = false;
				// 	});
			}
		},

		//显示资产选择
		selecAssets() {
			this.show_select_assets = true;
		},

		//选择资产成功回调
		onSelectSuccess(select_assets_ids, select_data) {
			this.show_select_assets = false;
			select_assets_ids.forEach((item) => {
				const index = this.form_data.assets_ids.findIndex((itm) => {
					return item == itm;
				});
				if (index == -1) {
					this.form_data.assets_ids.push(item);
				}
			});
			select_data.forEach((item) => {
				const index = this.selected_assets.findIndex((itm) => {
					return item.id == itm.id;
				});
				if (index == -1) {
					this.selected_assets.push(item);
				}
			});
		},

		//监听多选框选择
		handleSelectionChange(val) {
			this.del_selected_ids = [];
			val.forEach((item) => {
				this.del_selected_ids.push(item.id);
			});
		},

		//批量移除
		multiDel() {
			console.log(this.del_selected_ids);
			this.del_selected_ids.forEach((del_id) => {
				this.del(
					{
						id: del_id,
					},
					true
				);
			});
			//清空所有已选项
			this.del_selected_ids = [];
		},

		//移除单条数据
		del(row, is_multi = false) {
			console.log(row);
			const index = this.selected_assets.findIndex((item) => {
				return item.id == row.id;
			});

			if (index != -1) {
				this.selected_assets.splice(index, 1);
			}

			const id_index = this.form_data.assets_ids.findIndex((item) => {
				return item == row.id;
			});

			if (id_index != -1) {
				this.form_data.assets_ids.splice(id_index, 1);
			}

			if (!is_multi) {
				const del_index = this.del_selected_ids.findIndex((item) => {
					return item == row.id;
				});

				if (del_index != -1) {
					this.del_selected_ids.splice(del_index, 1);
				}
			}
		},

		//提交数据
		handleSubmit() {
			if (this.loading) return;
			this.$refs.form.validate((valid) => {
				if (valid) {
					if (this.form_data.assets_ids.length == 0) {
						this.$_msg.error("请至少选择一个处置资产");
						return;
					}
					this.submitting = true;
					this.form_data.source_id = this.$props.sourceId;
					this.form_data.dispose_source = this.$props.disposeSource;
					//添加
					this.$_invoke("assetsDispose_save", this.form_data)
						.then(() => {
							this.$_msg.success("提交成功");
							this.$emit("on-success");
						})
						.finally(() => {
							this.submitting = false;
						});
				}
			});
		},

		//移除图片
		handleRemove(file) {
			const index = this.form_data.files.findIndex((item) => {
				return item.url == file.response.data.file_url;
			});

			if (index != -1) {
				this.form_data.files.splice(index, 1);
			}
		},

		//上传图片成功回调
		handleImgUploadSuccess(response, file) {
			this.form_data.files.push({
				name: file.name,
				url: response.data.file_url,
			});
		},
	},
};
</script>
